module.exports = __webpack_public_path__ + "static/img/icon07.00fbc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon07.png
// module id = r2Q8
// module chunks = 1